import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin'
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faXing } from '@fortawesome/free-brands-svg-icons/faXing'
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { copyToClipboard } from '../../copyToClipboard/store/actions'
import { getAbsoluteUrl } from '../../utils/url'

export const ShareLinks = ({ escapedUrl, emailSubject, onClick, facebookIcon = faFacebook }) => (
  <>
    <a
      rel='nofollow noopener noreferrer'
      href={`mailto:?subject=${emailSubject}&body=${escapedUrl}`}
      className='share-item share-email'
      onClick={onClick}
    >
      <div className='share-icon'>
        <FontAwesomeIcon icon={faEnvelope} className='fa-fw' />
      </div>
      <div className='share-label'>
        Per E-Mail senden
      </div>
    </a>
    <a
      target='_blank' rel='nofollow noopener noreferrer'
      href={`https://www.facebook.com/sharer/sharer.php?u=${escapedUrl}`}
      className='share-item share-facebook'
      onClick={onClick}
    >
      <div className='share-icon'>
        <FontAwesomeIcon icon={facebookIcon} className='fa-fw' />
      </div>
      <div className='share-label'>
        Facebook
      </div>
    </a>
    <a
      target='_blank' rel='nofollow noopener noreferrer'
      href={`https://twitter.com/share?url=${escapedUrl}`}
      className='share-item share-twitter'
      onClick={onClick}
    >
      <div className='share-icon'>
        <FontAwesomeIcon icon={faTwitter} className='fa-fw' />
      </div>
      <div className='share-label'>
        Twitter
      </div>
    </a>
    <a
      target='_blank' rel='nofollow noopener noreferrer'
      href={`https://www.linkedin.com/shareArticle?url=${escapedUrl}`}
      className='share-item share-linkedin'
      onClick={onClick}
    >
      <div className='share-icon'>
        <FontAwesomeIcon icon={faLinkedin} className='fa-fw' />
      </div>
      <div className='share-label'>
        Linkedin
      </div>
    </a>
    <a
      target='_blank' rel='nofollow noopener noreferrer'
      href={`https://www.xing.com/spi/shares/new?url=${escapedUrl}`}
      className='share-item share-xing'
      onClick={onClick}
    >
      <div className='share-icon'>
        <FontAwesomeIcon icon={faXing} className='fa-fw' />
      </div>
      <div className='share-label'>
        Xing
      </div>
    </a>
  </>
)

ShareLinks.propTypes = {
  escapedUrl: PropTypes.string.isRequired,
  emailSubject: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  facebookIcon: PropTypes.object
}

const Share = ({ url, title, onClose }) => {
  const dispatch = useDispatch()

  const { absoluteUrl } = useMemo(() => ({
    absoluteUrl: getAbsoluteUrl(url)
  }), [url])

  const { escapedUrl, escapedTitle } = useMemo(() => ({
    escapedUrl: encodeURIComponent(absoluteUrl),
    escapedTitle: encodeURIComponent(title)
  }), [absoluteUrl, title])

  const handleCopyToClipboardClick = useCallback(() => {
    dispatch(copyToClipboard({ content: absoluteUrl, description: 'Link' }))
    onClose()
  }, [dispatch, absoluteUrl, onClose])

  return (
    <div className='share-group'>
      <ShareLinks escapedUrl={escapedUrl} emailSubject={escapedTitle} />
      <div className='share-item share-link input-group'>
        <input type='text' className='form-control' readOnly value={url} />
        <div className='input-group-append'>
          <button className='btn btn-share-link' type='button' onClick={handleCopyToClipboardClick}>
            <FontAwesomeIcon icon={faCopy} />
          </button>
        </div>
      </div>
    </div>
  )
}

Share.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired
}

export default Share
